exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".welcome-to-rcd-modal {\n  padding: 1em 5%;\n}\n.welcome-to-rcd-modal .welcome-text {\n  padding: 1.5em 0;\n}\n@media only screen and (min-width: 960px) {\n.welcome-to-rcd-modal {\n    padding: 1em 15%;\n}\n}\n", ""]);

// exports
